<template>
  <div>
    <div
        style="margin-top: 20px; color: rgb(0, 0, 0, 0.65);font-size: 15px;line-height: 35px ">
      <div>
        <el-row>
          <el-col :span="12">
            <p>
              <span class="title">订单编号：</span>
              <span>{{ refundOrder.id }} </span>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">原订单编号：</span>
              <span>{{ refundOrder.order_id }} </span>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">退单状态：</span>
              <el-tag>{{ refundOrder.approvalStatusName }}</el-tag>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">退单金额：</span>
              <span style="color: red;font-weight: bold">{{ refundOrder.refund_amount }} 元</span>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">退款方式：</span>
              <el-tag>{{ refundOrder.refundMethodName }}</el-tag>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">发起退单时间：</span>
              <span>{{ refundOrder.ctm }} </span>
            </p>
          </el-col>
          <el-col :span="24">
            <p>
              <span class="title">退单原因：</span>
              <span>{{ refundOrder.refund_reason }} </span>
            </p>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="24">
            <p>
              <span class="title">审核：</span>
              <el-radio-group v-model="approval_status">
                <el-radio v-for="(item,index) in approval_status_options" :label="item.value">{{
                    item.title
                  }}
                </el-radio>
              </el-radio-group>
            </p>
          </el-col>
          <el-col :span="24">
            <p style="display: flex;align-items: flex-start;margin-top: 10px">
              <span class="title">备注：</span>
              <el-input
                  v-model="approval_comment"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"></el-input>
            </p>
          </el-col>
        </el-row>

      </div>

    </div>

    <div class="toos_layer_footer">
      <el-button type="primary" @click=" submit">提交</el-button>
      <el-button type="primary" plain @click=" dialog.val = false;">取消</el-button>
    </div>
  </div>

</template>

<script>
import orderCountdown from "@/components/common/orderCountdown";

export default {
  name: "detail",
  props: ["dialog", "orderId", 'refundOrder'],
  components: {orderCountdown},
  data() {
    return {
      order: {},
      options2: [], //订单类型
      options3: [], //订单状态
      options9: [],//产品退款方式
      options10: [],//退单审核状态
      approval_status_options: [{
        title: '通过',
        value: '2'
      }, {
        title: '拒绝',
        value: '3'
      }],//审核选项
      approval_status: '2',//退单审核状态
      approval_comment: "",//退单审核备注
    }
  },
  methods: {
    // 获取字典值
    async getDictsData(dict) {
      let options = [];
      await this.$tools
          .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
            data: {
              dictionary_code: dict,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              options = res.data.data.dictionary_detail;
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      return options;
    },
    // 获取订单详情
    getOrderDetail() {
      this.$tools
          .asyncPost(this, this.$baseUrl.orderGet, {
            data: {
              id: this.orderId,
              order_role: JSON.parse(localStorage.getItem('useritem')).acctype
            }
          }).then(res => {
        if (res.data.code == 0) {
          this.order = res.data.data
          this.options2.forEach(item => {
            if (this.order.order_type == item.dictionary_key) {
              this.order.orderTypeName = item.dictionary_value
            }
          })
          this.options3.forEach(item => {
            if (this.order.status == item.dictionary_key) {
              this.order.orderStatusName = item.dictionary_value
            }
          })
        }
      })
    },
    //  提交审核结果
    submit(){
      this.$tools
          .asyncPost(this, this.$baseUrl.orderToExamine, {
            data: {
              id: this.orderId,
              order_id:this.refundOrder.order_id,
              order_role: "2",  // 平台端审批强制给固定企业类型,后期要给企业端使用那这里要给普通用户类型
              approval_status:this.approval_status,
              approval_comment:this.approval_comment
            }
          }).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.dialog.val = false
          this.$emit('updateRefundList')
        }
      })
    }
  },
  async mounted() {
    this.options2 = await this.getDictsData("PM-COMPANY-DDLX");
    this.options3 = await this.getDictsData("PM-COMPANY-DDZT");
    this.options10 = await this.getDictsData("TDGL-SPZT");
    this.options9 = await this.getDictsData("TDGL-TDFS");
    this.options10.forEach(item => {
      if (this.refundOrder.approval_status == item.dictionary_key) {
        this.refundOrder.approvalStatusName = item.dictionary_value
      }
    })
    this.options9.forEach(item => {
      if (this.refundOrder.refund_method == item.dictionary_key) {
        this.refundOrder.refundMethodName = item.dictionary_value
      }
    })
    this.$forceUpdate()

  }
}
</script>

<style scoped>
.title {
  font-weight: bold;
}

.pro-item-intro {
  padding: 15px;
}

.pro-item-intros {
  color: rgb(0, 0, 0, 0.65);
  font-size: 13px;
  margin-left: 10px
}

.pay-method-unselect {
  cursor: pointer;
  color: rgb(0, 0, 0, 0.65)
}

.pay-method-select {
  color: #42A1FF;
  cursor: pointer;
}

.flex-al-center {
  display: flex;
  align-items: center;
}
.toos_layer_footer{
  margin-top: 20px;
}
</style>